/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a constant, not a React component. */
import {
  columnFilteringFeature,
  columnVisibilityFeature,
  createExpandedRowModel,
  createFilteredRowModel,
  createSortedRowModel,
  filterFn_includesString as includesStringFilterFn,
  metaHelper,
  rowExpandingFeature,
  rowSortingFeature,
  sortFn_alphanumeric as alphanumericSortFn,
  tableFeatures,
} from '@tanstack/react-table';

import type { DimeColumnMeta } from '../DimeDataTable/TableFeatures.js';
import type { TableLoadingMeta } from '../table-internals/table-loading-meta.js';

// rowSelectionFeature is deliberately absent, matching DimeNestedTable — DimeTreeTable's
// selectedRowId/onSelectRow prop is a single-row picker convention, not TanStack row selection.
//
// expandedRowModel is the one feature slot DimeNestedTable does not register: that component
// never flattens children into the row model (it renders them itself via renderChildRows), while
// DimeTreeTable's whole premise is that TanStack computes the visible, depth-ordered row list from
// getSubRows + expanded state.
export const dimeTreeTableFeatures = tableFeatures({
  rowExpandingFeature,
  expandedRowModel: createExpandedRowModel(),
  rowSortingFeature,
  sortedRowModel: createSortedRowModel(),
  columnFilteringFeature,
  filteredRowModel: createFilteredRowModel(),
  columnVisibilityFeature,
  filterFns: { includesString: includesStringFilterFn },
  sortFns: { alphanumeric: alphanumericSortFn },
  columnMeta: metaHelper<DimeColumnMeta>(),
  tableMeta: metaHelper<TableLoadingMeta>(),
});

export type DimeTreeTableFeatures = typeof dimeTreeTableFeatures;
